import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  // 🚀 WICHTIG: Zeige Loading-State während Auth-Status geprüft wird
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-4"></div>
          <p className="text-gray-600">Prüfe Authentifizierung...</p>
        </div>
      </div>
    );
  }

  // 🚀 WICHTIG: Wenn nicht eingeloggt, zur Startseite weiterleiten
  if (!isAuthenticated) {
        navigate('/', { replace: true });
    return null;
  }

  // 🚀 WICHTIG: Wenn eingeloggt, geschützte Route anzeigen
    return children;
};

export default ProtectedRoute;
